import { request } from '@vtx/utils';
import http from './request';

export const getInfo = async (id, urlHead) => {
    const res = await http.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/gasStaff/get`, {
        body: { id },
        desensitized: true
    });
    if (res?.result === 0) {
        return res?.data;
    }
    return {};
};

export const getBottleOperateLogPage = (id, operateTypes, dataSearch, urlHead) => async (
    { current, pageSize },
    formData,
) => {
    const body = {
        page: current - 1,
        size: pageSize,
        operateTypes,
        ...dataSearch,
        operateUserId: id,
        ...formData,
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/bottleOperateLog/pageList`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};

export const getSecurityCheckRecordPage = (id, dataSearch, urlHead) => async ({ current, pageSize }) => {
    const body = {
        page: current - 1,
        size: pageSize,
        ...dataSearch,
        gasStaffId: id,
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/homeSecurityCheckRecord/page`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};
